export default __webpack_public_path__ + "static/media/1.369ebfb8.png";